import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import CONFIG from '../../config.js';

const logo = new URL('../assets/logo.jpg', import.meta.url);
const miniProgramQr = new URL('../assets/mini-program.jpg', import.meta.url);

const APP_FEATURES = [
  '赛事浏览与在线报名',
  '个人和团队报名支付',
  '视频课程与智慧课堂',
  '赛事直播实时观看',
  '多难度AI人机对弈',
  '新闻资讯与活动相册',
  '每日签到与积分系统',
  '证书申请与管理',
];

export default function Download() {
  return (
    <Box>
      {/* 顶部区域 */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1A1A1A 0%, #2D1810 100%)',
          color: '#fff',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <Box
            component="img"
            src={logo}
            alt="中象在线"
            sx={{
              width: 100,
              height: 100,
              borderRadius: 3,
              mb: 3,
              boxShadow: '0 4px 20px rgba(184,134,11,0.3)',
            }}
          />
          <Typography variant="h2" sx={{ mb: 2, fontWeight: 700 }}>
            下载中象在线
          </Typography>
          <Typography variant="h6" sx={{ color: 'grey.400', fontWeight: 400, maxWidth: 500, mx: 'auto' }}>
            多平台支持，随时随地学棋、练棋、比赛
          </Typography>
        </Container>
      </Box>

      {/* 下载卡片 */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 }, mt: -6 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
            gap: 4,
            alignItems: 'stretch',
          }}
        >
          {/* 微信小程序 - 二维码 */}
          <Card
            sx={{
              textAlign: 'center',
              p: 4,
              border: '2px solid #07C160',
            }}
          >
            <CardContent>
              <Box
                component="img"
                src={miniProgramQr}
                alt="中象在线微信小程序二维码"
                sx={{
                  width: 200,
                  height: 200,
                  borderRadius: 2,
                  mb: 3,
                }}
              />
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
                微信小程序
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                使用微信扫描上方二维码
              </Typography>
              <Typography variant="body2" color="text.secondary">
                即可进入中象在线小程序
              </Typography>
            </CardContent>
          </Card>

          {/* Android */}
          <Card
            sx={{
              textAlign: 'center',
              p: 4,
              border: '2px solid',
              borderColor: 'divider',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                bgcolor: 'grey.100',
                color: 'text.secondary',
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.75rem',
                fontWeight: 600,
              }}
            />
            <CardContent>
              <Box sx={{ color: '#3DDC84', mb: 2 }}>
                <AndroidIcon sx={{ fontSize: 64 }} />
              </Box>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
                Android
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                支持 Android 7.0 及以上版本
              </Typography>
              {CONFIG.download.android && CONFIG.download.android !== '#' ? (
                <Button
                  variant="contained"
                  size="large"
                  href={CONFIG.download.android}
                  sx={{
                    bgcolor: '#3DDC84',
                    color: '#000',
                    '&:hover': { bgcolor: '#3DDC84', filter: 'brightness(0.9)' },
                  }}
                >
                  下载 APK
                </Button>
              ) : (
                <Button variant="contained" size="large" disabled sx={{ '&.Mui-disabled': { bgcolor: 'grey.300' } }}>
                  即将上线
                </Button>
              )}
            </CardContent>
          </Card>

          {/* iOS */}
          <Card
            sx={{
              textAlign: 'center',
              p: 4,
              border: '2px solid',
              borderColor: 'divider',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <CardContent>
              <Box sx={{ color: '#000', mb: 2 }}>
                <AppleIcon sx={{ fontSize: 64 }} />
              </Box>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
                iOS
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                支持 iOS 13.0 及以上版本
              </Typography>
              <Button variant="contained" size="large" disabled sx={{ '&.Mui-disabled': { bgcolor: 'grey.300' } }}>
                即将上线
              </Button>
            </CardContent>
          </Card>
        </Box>
      </Container>

      {/* 功能列表 */}
      <Box sx={{ bgcolor: 'grey.50', py: { xs: 8, md: 10 } }}>
        <Container maxWidth="md">
          <Typography variant="h3" align="center" sx={{ mb: 6, fontWeight: 700 }}>
            应用功能一览
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              gap: 2,
            }}
          >
            {APP_FEATURES.map((feature) => (
              <Stack key={feature} direction="row" spacing={1.5} alignItems="center">
                <CheckCircleIcon sx={{ color: 'primary.main', fontSize: 22 }} />
                <Typography variant="body1" sx={{ fontSize: '1.05rem' }}>
                  {feature}
                </Typography>
              </Stack>
            ))}
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
